import React from 'react';
import PropTypes from 'prop-types';
import UserManagementStore from '../../stores/UserManagementStore';
import EgainStore from '../../stores/EgainStore';
import EgainActionCreator from '../../actions/EgainActionCreator';
import { getChat } from '../../egainChat/eGainChat';
import { getSMEChat } from '../../egainChat/eGainChatSME';
import { LiveChatTile } from './SideBarTiles/LiveChatTile';
import { GenericModal } from 'web-ui-components/lib/layout/content';

export const getChatContent = ({
  genericChatHeading,
  genericChatDescription,
  genericChatButtonText,
  eGainChatModelHeader,
  eGainChatModelButtonText,
  eGainChatModelText,
}) => ({
  genericChatHeading,
  genericChatDescription,
  genericChatButtonText,
  eGainChatModelHeader,
  eGainChatModelButtonText,
  eGainChatModelText,
});

export class GenericChatComponent extends React.Component {
  constructor() {
    super();
    this.initiateChat = this.initiateChat.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onChatClick = this.onChatClick.bind(this);
    this.state = {
      showModal: false,
      saml: '',
      egainChat: UserManagementStore.isSMEUser() ? getSMEChat() : getChat(),
    };
  }

  componentDidMount() {
    EgainStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    EgainStore.removeChangeListener(this.onStoreChange);
  }

  onChatClick() {
    try {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    } catch (error) {
      window.dtrum?.reportError(error);
    }
    this.onModalClose();
  }

  onStoreChange() {
    const token = EgainStore.getSamlToken();
    if (this.state.saml !== token) {
      this.setState({
        saml: token,
      });
    }
  }
  initiateChat() {
    EgainActionCreator.getSamlToken();
    this.setState({
      showModal: true,
    });
  }

  onModalClose() {
    this.setState({ showModal: false });
  }

  render() {
    const {
      genericChatHeading,
      genericChatDescription,
      genericChatButtonText,
      eGainChatModelHeader,
      eGainChatModelButtonText,
      eGainChatModelText,
    } = this.props.content;
    const { showModal } = this.state;
    return (
      <div>
        <LiveChatTile
          content={{
            genericChatHeading,
            genericChatDescription,
            genericChatButtonText,
          }}
          initiateChat={this.initiateChat}
        />
        {showModal && (
          <GenericModal
            titleText={eGainChatModelHeader}
            onConfirm={this.onChatClick}
            isOpen={showModal}
            onClose={this.onModalClose}
            confirmButtonText={eGainChatModelButtonText}
            isCentred
          >
            <p>{eGainChatModelText}</p>
          </GenericModal>
        )}
      </div>
    );
  }
}

GenericChatComponent.propTypes = {
  content: PropTypes.object,
};
